import axios from "axios"
import { post, del, get, put } from "./api_helper"
import * as url from "./url_helper"


export const fetchAllCategory = () => get(url.FETCH_ALL_CATEGORY);
export const fetchAllSubCategory = () => get(url.FETCH_ALL_SUBCATEGORY);

export const getAllSubCategoriesBasedOnCategories = data => post(url.GET_ALL_SUBCATEGORIES_BASED_ON_CATEGORIES, data);